import React from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withLocalize } from "react-localize-redux";
import BbPopover from "../../common/popover";
import PropTypes from "prop-types";
import ResponsiveTable from "../../layoutItems/responsiveTable";
import Semaphore from "./semaphore";
import UnderlinedTitle from "../../common/underlinedTitle";
import ReactHtmlParser from "react-html-parser";

class AmlExplanatoryNotes extends React.Component {
  render() {
    return (
      <div style={{ maxHeight: "400px", overflow: "auto" }}>
        <ResponsiveTable>
          <table className="table table-report-section">
            <thead>
              <tr>
                <th>AMLInfoCheck</th>
                <th>{this.props.translate("Report.Common.Note")}</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  color: "green",
                  localization: "Report.Aml.Explanatory.SubjectNotFound",
                },
                {
                  color: "yellow",
                  localization: "Report.Aml.Explanatory.SubjectFound",
                },
                {
                  color: "red",
                  localization:
                    "Report.Aml.Explanatory.SubjectFoundInSanctionLists",
                },
              ].map((semaphore) => (
                <tr key={semaphore.color} className="colorize">
                  <td className="always-new-line" data-label="AMLInfoCheck">
                    <Semaphore
                      color={semaphore.color}
                      width={43}
                      height={43}
                      className="aml-semaphore-centered vertically"
                    />
                  </td>
                  <td data-label={this.props.translate("Report.Common.Note")}>
                    <span>{this.props.translate(semaphore.localization)}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </ResponsiveTable>
      </div>
    );
  }
}

class AmlExplanatoryNotesSecond extends React.Component {
  static propTypes = {
    splitByPep: PropTypes.bool,
    methodology: PropTypes.bool,
  };

  static defaultProps = {
    splitByPep: false,
    methodology: false,
  };

  render() {
    const desc = ReactHtmlParser(
      this.props.translate("Report.Aml.Explanatory.LastUpdateDate")
    );

    return (
      <div>
        <UnderlinedTitle
          header={this.props.translate("Report.Explanatory.Tooltip")}
        />
        <ResponsiveTable>
          {!this.props.splitByPep &&
            this.renderTable(
              this.props.data.listDescriptions,
              "Report.Aml.Explanatory.Sources",
              "explanatory-sources"
            )}
          {this.props.splitByPep &&
            this.renderTable(
              this.props.data.listDescriptions.filter((l) => l.isPep === true),
              "Report.Aml.Explanatory.Sources.PEP",
              "explanatory-sources-pep"
            )}
          {this.props.splitByPep &&
            this.renderTable(
              this.props.data.listDescriptions.filter((l) => l.isPep === false),
              "Report.Aml.Explanatory.Sources.ExceptPEP",
              "explanatory-sources-exceptPep"
            )}
        </ResponsiveTable>
        <div style={{ display: "grid" }}>
          <div style={{ display: "flex" }}>
            <p>
              {this.props.translate("Report.Aml.Explanatory.Decision", null, {
                renderInnerHtml: true,
              })}
            </p>
            <span>
              <BbPopover
                amlData={this.props.data}
                content={this.props.translate("Report.Explanatory.Tooltip")}
                addInfo={"AmlGlobalEval"}
                placement="right"
                targetId={"AmlExplanatoryNotes"}
              >
                <span
                  href="#"
                  className="icon-gray print-hidden"
                  id={"AmlExplanatoryNotes"}
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon icon="question-circle" />
                </span>
              </BbPopover>
            </span>
          </div>
          <div>{desc}</div>
        </div>

        {this.props.methodology && (
          <p>
            {this.props.translate(
              this.props.data.methodology === "cos"
                ? "Report.Aml.Explanatory.MethodologyCos"
                : "Report.Aml.Explanatory.MethodologyDos",
              null,
              { renderInnerHtml: true }
            )}
          </p>
        )}
      </div>
    );
  }

  renderTable = (data, sourcesLabel, popoverId) => {
    const desc = ReactHtmlParser(
      this.props.translate("Report.Aml.Explanatory.LastUpdateDate")
    );

    return (
      <table className="table table-report-section">
        <thead>
          <tr>
            <th style={{ width: "25%" }}>
              {this.props.translate(sourcesLabel)}
            </th>
            <th style={{ width: "50%" }}>
              {this.props.translate("Report.Aml.Explanatory.Authority")}
            </th>
            <th style={{ width: "25%" }}>
              <span>
                {this.props.translate("Report.Aml.Explanatory.DateLastUpdated")}
              </span>
              <span style={{ marginLeft: ".35em" }}>
                <BbPopover
                  addInfo="LastUpdateDate"
                  amlData={this.props.data}
                  content={desc}
                  placement="right"
                  targetId={"AmlDateOfLastUpdateExplanatoryNote" + popoverId}
                >
                  <span
                    href="#"
                    className="icon-gray print-hidden"
                    id={"AmlDateOfLastUpdateExplanatoryNote" + popoverId}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon icon="question-circle" style={{marginLeft: "0.5em"}} />
                  </span>
                </BbPopover>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((description) => (
            <tr key={description.name} className="colorize">
              <td
                className="always-new-line"
                data-label={this.props.translate(
                  "Report.Aml.Explanatory.Sources"
                )}
              >
                <span>{description.name}</span>
              </td>
              <td
                data-label={this.props.translate(
                  "Report.Aml.Explanatory.Authority"
                )}
              >
                <span>{description.publishingOrganization}</span>
              </td>
              <td
                data-label={this.props.translate(
                  "Report.Aml.Explanatory.DateLastUpdated"
                )}
              >
                <span>{description.dateLastUpdatedFormatted}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
}

export default AmlExplanatoryNotes = connect((state) => state.report)(
  AmlExplanatoryNotes
);
export const AmlExplanatoryNotes2 = withLocalize(AmlExplanatoryNotesSecond);
